import { EDITORIAL_REVIEWER_UI_READY } from 'app/config/editorialReviewer.config';
import { getEditorialCapabilities } from 'app/models/editorialCapabilities';
import { USER_ROLES } from 'app/models/user/user.constants';

let session = null;
let scope = null;
let revision = 0;

export function getEditorialRequestRevision() {
  return revision;
}

export function publishEditorialRequestSession(owner, access, authToken) {
  revision++;
  session = { owner, access, authToken, paused: false };
}

export function pauseEditorialRequestSession(owner) {
  if (session?.owner === owner) {
    revision++;
    session = { ...session, paused: true };
  }
}

export function releaseEditorialRequestSession(owner) {
  if (session?.owner === owner) {
    revision++;
    session = null;
  }
}

export function publishEditorialRequestScope(owner, resources) {
  revision++;
  scope = { owner, resources, paused: false };
}

export function pauseEditorialRequestScope(owner) {
  if (scope?.owner === owner) {
    revision++;
    scope = { ...scope, paused: true };
  }
}

export function releaseEditorialRequestScope(owner) {
  if (scope?.owner === owner) {
    revision++;
    scope = null;
  }
}

export function canSendEditorialRequest(config, authToken) {
  if (!EDITORIAL_REVIEWER_UI_READY || config.editorialAction === undefined) return true;
  if (
    !['read', 'write'].includes(config.editorialAction) ||
    !session ||
    !authToken ||
    session.authToken !== authToken ||
    !Object.values(USER_ROLES).includes(session.access?.role)
  )
    return false;
  if (session.access.role !== USER_ROLES.publisher) return true;
  // La revision solo puede invalidar a quien esta sujeto a la feature: sube en cada publish/pause
  // del arranque y los efectos de React corren de hijo a padre, asi que toda peticion lanzada al
  // montar una pagina nacia desfasada y moria cancelada aunque el rol nunca estuviera restringido.
  // Un R07 ya resuelto como no restringido conserva su acceso mientras se revalida: el resultado de /me
  // cerrará el paso si el perfil cambió, sin descartar entre medias el clic que devolvió el foco.
  if (session.access.status === 'ready' && session.access.data?.restricted === false) return true;
  if (config.editorialRevision !== revision) return false;
  if (session.paused || session.access.revalidating || session.access.status !== 'ready') return false;
  if (!session.access.data || typeof session.access.data.restricted !== 'boolean') return false;
  if (!scope || !Array.isArray(scope.resources) || scope.paused || scope.resources.some((resource) => resource?.revalidating)) return false;
  const capabilities = getEditorialCapabilities(session.access, scope.resources);
  return config.editorialAction === 'read' ? capabilities.canRead : capabilities.canWrite;
}
